import { create } from "zustand";

interface TableMeta {
  name: string;
  gmUid: string;
  channelId?: string;
  guildId?: string;
  locale?: "en" | "zh-TW";
  visibility?: "private" | "public";
}

interface TableState {
  tableId: string | null;
  meta: TableMeta | null;
  setTable: (tableId: string, meta: TableMeta) => void;
  clear: () => void;
}

export const useTableStore = create<TableState>((set) => ({
  tableId: null,
  meta: null,
  setTable: (tableId, meta) => set({ tableId, meta }),
  clear: () => set({ tableId: null, meta: null }),
}));
